import type { Locale } from '../type';

const localeValues: Locale = {
  locale: 'ro',
  Pagination: {
    items_per_page: '/ pagină',
    jump_to: 'Mergi la',
    jump_to_confirm: 'confirm',
    page: '',
    prev_page: 'Pagina Anterioară',
    next_page: 'Pagina Următoare',
    prev_5: '5 Pagini Anterioare',
    next_5: '5 Pagini Următoare',
    prev_3: '3 Pagini Anterioare',
    next_3: '3 Pagini Următoare',
  },
  DatePicker: {
    lang: {
      placeholder: 'Selectează data',
      rangePlaceholder: [
        'Data start',
        'Data sfârșit',
      ],
      locale: 'ro_RO',
      today: 'Azi',
      now: 'Acum',
      backToToday: 'Înapoi la azi',
      ok: 'Ok',
      clear: 'Șterge',
      month: 'Lună',
      year: 'An',
      timeSelect: 'selectează timpul',
      dateSelect: 'selectează data',
      weekSelect: 'Alege o săptămână',
      monthSelect: 'Alege o lună',
      yearSelect: 'Alege un an',
      decadeSelect: 'Alege un deceniu',
      yearFormat: 'YYYY',
      dateFormat: 'D/M/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D/M/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Luna anterioară (PageUp)',
      nextMonth: 'Luna următoare (PageDown)',
      previousYear: 'Anul anterior (Control + stânga)',
      nextYear: 'Anul următor (Control + dreapta)',
      previousDecade: 'Deceniul anterior',
      nextDecade: 'Deceniul următor',
      previousCentury: 'Secolul anterior',
      nextCentury: 'Secolul următor',
    },
    timePickerLocale: {
      placeholder: 'Selectează ora',
    },
  },
  TimePicker: {
    placeholder: 'Selectează ora',
  },
  Calendar: {
    lang: {
      placeholder: 'Selectează data',
      rangePlaceholder: [
        'Data start',
        'Data sfârșit',
      ],
      locale: 'ro_RO',
      today: 'Azi',
      now: 'Acum',
      backToToday: 'Înapoi la azi',
      ok: 'Ok',
      clear: 'Șterge',
      month: 'Lună',
      year: 'An',
      timeSelect: 'selectează timpul',
      dateSelect: 'selectează data',
      weekSelect: 'Alege o săptămână',
      monthSelect: 'Alege o lună',
      yearSelect: 'Alege un an',
      decadeSelect: 'Alege un deceniu',
      yearFormat: 'YYYY',
      dateFormat: 'D/M/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D/M/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Luna anterioară (PageUp)',
      nextMonth: 'Luna următoare (PageDown)',
      previousYear: 'Anul anterior (Control + stânga)',
      nextYear: 'Anul următor (Control + dreapta)',
      previousDecade: 'Deceniul anterior',
      nextDecade: 'Deceniul următor',
      previousCentury: 'Secolul anterior',
      nextCentury: 'Secolul următor',
    },
    timePickerLocale: {
      placeholder: 'Selectează ora',
    },
  },
  global: {
    placeholder: 'Selectează',
  },
  Table: {
    filterTitle: 'Filtrează',
    filterConfirm: 'OK',
    filterReset: 'Resetează',
    filterEmptyText: 'Fără filtre',
    emptyText: 'Nu există date',
    selectAll: 'Selectează pagina curentă',
    selectInvert: 'Inversează pagina curentă',
    selectNone: 'Șterge selecția',
    selectionAll: 'Selectează toate datele',
    sortTitle: 'Ordonează',
    expand: 'Extinde rândul',
    collapse: 'Micșorează rândul',
    triggerDesc: 'Apasă pentru ordonare descrescătoare',
    triggerAsc: 'Apasă pentru ordonare crescătoare',
    cancelSort: 'Apasă pentru a anula ordonarea',
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Anulare',
    justOkText: 'OK',
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Anulare',
  },
  Transfer: {
    titles: [
      '',
      '',
    ],
    searchPlaceholder: 'Căutare',
    itemUnit: 'element',
    itemsUnit: 'elemente',
    remove: 'Șterge',
    selectCurrent: 'Selectează pagina curentă',
    removeCurrent: 'Șterge pagina curentă',
    selectAll: 'Selectează toate datele',
    removeAll: 'Șterge toate datele',
    selectInvert: 'Inversează pagina curentă',
  },
  Upload: {
    uploading: 'Se transferă...',
    removeFile: 'Înlătură fișierul',
    uploadError: 'Eroare la upload',
    previewFile: 'Previzualizare fișier',
    downloadFile: 'Descărcare fișier',
  },
  Empty: {
    description: 'Fără date',
  },
  Icon: {
    icon: 'icon',
  },
  Text: {
    edit: 'editează',
    copy: 'copiază',
    copied: 'copiat',
    expand: 'extinde',
  },
  PageHeader: {
    back: 'înapoi',
  },
  Form: {
    optional: '(opțional)',
    defaultValidateMessages: {
      default: 'Eroare la validarea câmpului ${label}',
      required: 'Vă rugăm introduceți ${label}',
      enum: '${label} trebuie să fie una din valorile [${enum}]',
      whitespace: '${label} nu poate fi gol',
      date: {
        format: '${label} - data nu este în formatul corect',
        parse: '${label} nu poate fi convertit la o dată',
        invalid: '${label} este o dată invalidă',
      },
      types: {
        string: '${label} nu conține tipul corect (${type})',
        method: '${label} nu conține tipul corect (${type})',
        array: '${label} nu conține tipul corect (${type})',
        object: '${label} nu conține tipul corect (${type})',
        number: '${label} nu conține tipul corect (${type})',
        date: '${label} nu conține tipul corect (${type})',
        boolean: '${label} nu conține tipul corect (${type})',
        integer: '${label} nu conține tipul corect (${type})',
        float: '${label} nu conține tipul corect (${type})',
        regexp: '${label} nu conține tipul corect (${type})',
        email: '${label} nu conține tipul corect (${type})',
        url: '${label} nu conține tipul corect (${type})',
        hex: '${label} nu conține tipul corect (${type})',
      },
      string: {
        len: '${label} trebuie să conțină ${len} caractere',
        min: '${label} trebuie să conțină cel puțin ${min} caractere',
        max: '${label} trebuie să conțină cel mult ${max} caractere',
        range: '${label} trebuie să conțină între ${min}-${max} caractere',
      },
      number: {
        len: '${label} trebuie să conțină ${len} cifre',
        min: '${label} trebuie să fie minim ${min}',
        max: '${label} trebuie să fie maxim ${max}',
        range: '${label} trebuie să fie între ${min}-${max}',
      },
      array: {
        len: '${label} trebuie să conțină ${len} elemente',
        min: '${label} trebuie să conțină cel puțin ${min} elemente',
        max: '${label} trebuie să conțină cel mult ${max} elemente',
        range: '${label} trebuie să conțină între ${min}-${max} elemente',
      },
      pattern: {
        mismatch: '${label} nu respectă șablonul ${pattern}',
      },
    },
  },
  Image: {
    preview: 'Preview',
  },
};

export default localeValues;
